export const baseAddress = 'https://cpohubapi.azurewebsites.net';
export const authority = "https://bmsnet.online/login/";
export const client_id = "chargepointhubweb";
export const redirect_uri = "https://cpohubweb.azurewebsites.net/";